module.exports = __webpack_public_path__ + "img/Puffer.ef28b3c0.png";